import { Link } from "react-router-dom";
import { useGroq } from "../lib/sanity";
import { imageIdToURL } from "../utils/LinkUtils";
import { useSeo } from "../utils/useSeo";

const TEAMS_QUERY = `{
  "team": *[_type == "team"] | order(game->name asc, name asc, suffix asc){
    "id": _id,
    name,
    suffix,
    "slug": slug.current,
    "game": game->{ name, icon }
  }
}`;

const Teams = () => {
  useSeo({
    title: "Teams",
    description: "Brown Esports' competitive and casual gaming teams.",
  });
  const { loading, error, data } = useGroq<any>(TEAMS_QUERY);
  const teams = !loading && !error && data?.team ? data.team : [];

  return (
    <div className="bg-gray-900 text-gray-100 min-h-screen">
      <div className="container mx-auto px-8 pt-28 md:pt-36 pb-16">
        <h1 className="font-header font-bold text-5xl md:text-7xl text-center mb-4">
          Our Teams
        </h1>
        <p className="text-center text-gray-400 font-body max-w-2xl mx-auto mb-12">
          Brown Esports fields competitive rosters across a range of titles.
        </p>

        {loading ? (
          <div className="text-center text-gray-400">Loading teams…</div>
        ) : teams.length === 0 ? (
          <div className="text-center text-gray-400">
            No teams yet — check back soon.
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 max-w-5xl mx-auto">
            {teams.map((team: any) => (
              <Link to={`/teams/${team.slug}`} key={team.id}>
                <div className="flex items-center bg-gray-800 hover:bg-gray-750 rounded-lg p-4 transition-all duration-75">
                  <div className="bg-gray-650 w-16 h-16 rounded-md mr-4 flex-shrink-0 flex items-center justify-center">
                    <img
                      src={imageIdToURL(team.game?.icon)}
                      alt={(team.game?.name || "Game") + " logo"}
                      className="w-10 h-10 object-contain"
                    />
                  </div>
                  <div className="flex flex-col">
                    <div className="font-bold font-header text-lg tracking-wide text-white">
                      {team.game?.name || team.name}
                    </div>
                    {team.suffix ? (
                      <div className="text-sm text-gray-300">{team.suffix}</div>
                    ) : null}
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Teams;
